import { useMemo, useState } from "react"

export const useGetRequiredSearchParams = (url, ...params) => {
  const [isNoValue, setIsNoValue] = useState(true)
  const searchParams = url?.split("?")[1]

  const paramIds = useMemo(() => {
    const obj = {}

    const params1 = new URLSearchParams(searchParams)

    params.forEach(param => {
      const value = params1.get(param)
      obj[param] = value ? decodeURIComponent(value) : "No value"
      if (obj[param] !== "No value") {
        setIsNoValue(false)
      }
    })

    return obj
  }, [url])

  return [paramIds, isNoValue, setIsNoValue]
}
